import { render, staticRenderFns } from "./ChatGPTMedia.vue?vue&type=template&id=48b567fa&scoped=true&"
import script from "./ChatGPTMedia.vue?vue&type=script&lang=js&"
export * from "./ChatGPTMedia.vue?vue&type=script&lang=js&"
import style0 from "./ChatGPTMedia.vue?vue&type=style&index=0&id=48b567fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b567fa",
  null
  
)

export default component.exports